import { render, staticRenderFns } from "./StepDiabetes.vue?vue&type=template&id=2d649910"
import script from "./StepDiabetes.vue?vue&type=script&lang=js"
export * from "./StepDiabetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports